class Map {
	constructor(elemId) {
		this.elemId = elemId;

		this.initMap = this.initMap.bind(this);
		this.createMap = this.createMap.bind(this);

		this.initMap();
	}

	createMap(element) {
		const x = element.getAttribute('data-x');
		const y = element.getAttribute('data-y');
		const zoom = element.getAttribute('data-zoom');

		const map = new ymaps.Map(this.elemId, {
			center: [x, y],
			zoom,
		});

		let myPlacemark = new ymaps.Placemark(
			map.getCenter(),
			{},
			{
				iconLayout: 'default#image',
				iconImageHref: '/images/sprites/svg/pin.svg',
				iconImageSize: [85, 92],
				iconImageOffset: [-22.5, -26],
			},
		);

		map.geoObjects.add(myPlacemark);
	}

	initMap() {
		console.log('ymaps before');
		const elemId = this.elemId;
		const createMap = this.createMap;

		ymaps.ready(() => {
			console.log('ymaps ready');
			const domElem = document.getElementById(elemId);

			if (domElem) {
				createMap(domElem);
			}
		});
	}
}

function init() {
	const contactsMap = new Map('contactsMap');
}

export default {
	init,
};
